module.exports = __webpack_public_path__ + "media/src/images/header/dots-ecdb1bb2479a200f23378ce8865a2dee.svg";